import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminPageHeader } from "./_helpers";

export default function AdminSupport() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/support").then((r) => setItems(r.data));
  useEffect(load, []);
  const setStatus = async (id, status) => { await api.put(`/support/${id}/status?status=${status}`); load(); };
  return (
    <div>
      <AdminPageHeader title="Destek Talepleri" />
      <div className="bg-white border border-gray-100 rounded-lg">
        {items.map((t) => (
          <div key={t.id} className="p-4 border-b last:border-0">
            <div className="flex items-center justify-between">
              <div className="font-semibold">{t.subject}</div>
              <span className="text-xs px-2 py-0.5 bg-gray-100 rounded">{t.status}</span>
            </div>
            <div className="text-sm text-gray-600 mt-1 whitespace-pre-wrap">{t.message}</div>
            <div className="text-xs text-gray-500 mt-1">{t.user_email}</div>
            <div className="mt-2 flex gap-2">
              {["open", "in_progress", "resolved", "closed"].map((s) => (
                <button key={s} onClick={() => setStatus(t.id, s)} className="text-xs px-2 py-1 border rounded hover:bg-gray-50">{s}</button>
              ))}
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="p-8 text-center text-gray-500 text-sm">Henüz talep yok</div>}
      </div>
    </div>
  );
}
